import { DatePicker } from 'antd';
import { useState } from 'react';
import IcApt from 'assets/Icons/IcApt';
import colorTheme from 'constants/color';
import styled from 'styled-components';
import { Dayjs } from 'dayjs';
import { useAppDispatch } from 'store/hooks';
import turnActions from 'features/turn/services/actions';

interface DatePickerTurnProps {
  value?: Dayjs;
  onChange?: (date: Dayjs) => void;
}
const DatePickerTurn = ({ value, onChange }: DatePickerTurnProps) => {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();

  const handleChangeDate = async (date: Dayjs | null) => {
    if (date) {
      onChange?.(date);
    }
    dispatch(turnActions.turnManualAPIActions.getTurns.fetch({ date: date?.format('MM-DD-YYYY') }));
    dispatch(turnActions.getTurnStaffsAvailable.fetch({ date: date?.format('MM-DD-YYYY') }));
  };
  return (
    <Container onClick={() => setOpen(true)}>
      <IcApt width={60} height={60} fill={colorTheme.v2_secondary_3} />

      <DatePicker
        open={open}
        onOpenChange={(val) => setOpen(val)}
        style={{ position: 'absolute', opacity: 0 }}
        onChange={handleChangeDate}
        value={value ? value : null}
        popupClassName='styled-calendar'
        disabledDate={(current) => {
          const today = new Date();
          return current && current.toDate() > today;
        }}
      />
    </Container>
  );
};

export default DatePickerTurn;

const Container = styled.button`
  position: relative;
  background: transparent;
  border: none;
  padding: 0;
  margin-left: 24px;

  .ant-picker-dropdown.styled-calendar .ant-picker-panel-layout {
    zoom: 2.0;
  }
`;
